import React, {
  FunctionComponent,
  useState,
  useContext,
  FormEvent,
} from "react";
import styles from "./Feedback.module.scss";
import {
  ArrowDropDownRounded,
  ArrowDropUpRounded,
  AddRounded,
  CheckRounded,
  ArrowUpwardRounded,
  ArrowDownwardRounded,
} from "@material-ui/icons";
import CardUser from "shared/components/CardUser/CardUser";
import Replies from "../Replies/Replies";
import MUButton from "@material-ui/core/Button";

import Collapse from "@material-ui/core/Collapse";

import AppContext from "context/AppContext";

import moment from "moment";
import Button from "shared/components/Buttons/Button";
import apiCalls from "shared/utils/apiCalls";
import CircularProgress from "@material-ui/core/CircularProgress";
import cn from "classnames";
import Modal from "shared/components/Modal/Modal";
import ErrorMessage from "shared/components/ErrorMessage/ErrorMessage";
import { Errors } from "shared/types/errors";
import { Link } from "react-router-dom";
import { TextareaAutosize } from "@material-ui/core";
import ReactMarkdown from "react-markdown";
import CodeBlock from "shared/components/CodeBlock/CodeBlock";

const Feedback: FunctionComponent<{
  feedback: any;
  getFeedbacks?: any;
  showReplies?: boolean;
}> = ({ feedback, getFeedbacks, showReplies = true }) => {
  const [openReply, setOpenReply] = useState(true);
  const [editting, setEditting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [voteLoading, setVoteLoading] = useState(false);
  const [updatedContent, setUpdatedContent] = useState<any>(feedback.content);
  const { state, dispatch } = useContext(AppContext);
  const [
    permissionDeclinedModalOpen,
    setPermissionDeclinedModalOpen,
  ] = useState(false);

  const [endorsementExisted, setEndorsementExisted] = useState(false);
  const [endorsing, setEndorsing] = useState(false);
  const [endorsed, setEndorsed] = useState(false);

  const endorse = async (name: string, uid: string) => {
    setEndorsing(true);
    const res = await apiCalls(
      {
        method: "post",
        data: {
          name,
          uid,
        },
        url: `/skills/add/endorse`,
      },
      dispatch
    );

    if (!res) {
      setEndorsementExisted(true);
    }

    setEndorsed(true);
    setEndorsing(false);
  };

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const submit = async () => {
      setLoading(true);
      const res = await apiCalls(
        {
          method: "put",
          data: { content: updatedContent },
          url: `/feedbacks/${feedback.id}`,
        },
        dispatch
      );

      if (res) {
        await getFeedbacks();
      }

      setLoading(false);

      setEditting(false);
    };

    submit();
  };

  const upvote = async () => {
    if (!state.user) {
      return;
    }

    if (state.user.reputations < 0) {
      setPermissionDeclinedModalOpen(true);
      return;
    }

    setVoteLoading(true);
    const res = await apiCalls(
      {
        method: "put",
        url: `/feedbacks/upvote/${feedback.id}`,
      },
      dispatch
    );

    if (res) {
      await getFeedbacks();
    }

    setVoteLoading(false);
  };

  const downvote = async () => {
    if (!state.user) {
      return;
    }

    if (state.user.reputations < 0) {
      setPermissionDeclinedModalOpen(true);
      return;
    }

    setVoteLoading(true);
    const res = await apiCalls(
      {
        method: "put",
        url: `/feedbacks/downvote/${feedback.id}`,
      },
      dispatch
    );

    if (res) {
      await getFeedbacks();
    }

    setVoteLoading(false);
  };

  const getVoteNumber = () => {
    let upvotes = 0;
    let downvotes = 0;

    if (feedback.upvotes) {
      upvotes = feedback.upvotes.length;
    }

    if (feedback.downvotes) {
      downvotes = feedback.downvotes.length;
    }

    return upvotes - downvotes;
  };

  return (
    <div className={styles.feedback}>
      <Modal
        open={permissionDeclinedModalOpen}
        closeModal={() => setPermissionDeclinedModalOpen(false)}
        size="sm"
      >
        <ErrorMessage errorType={Errors.reputationsDeclined} />
      </Modal>

      <Modal
        open={endorsementExisted}
        closeModal={() => setEndorsementExisted(false)}
        size="sm"
      >
        <ErrorMessage
          errorType={Errors.endorsementExisted}
          close={() => setEndorsementExisted(false)}
        />
      </Modal>
      <div>
        <div className={styles.feedback_vote}>
          <button
            className={cn(styles.feedback_voteIcons, {
              [styles.feedback_upvote__active]:
                feedback.upvotes && feedback.upvotes.includes(state.user?.uid),
            })}
            onClick={upvote}
          >
            <ArrowUpwardRounded fontSize="inherit" />
          </button>

          {voteLoading ? (
            <div className={cn(styles.feedback_vote_loader)}>
              <CircularProgress size={12} thickness={4} />
            </div>
          ) : (
            <div
              className={cn(styles.feedback_voteNumber, {
                [styles.feedback_upvote__active]:
                  feedback.upvotes &&
                  feedback.upvotes.includes(state.user?.uid),
                [styles.feedback_downvote__active]:
                  feedback.downvotes &&
                  feedback.downvotes.includes(state.user?.uid),
              })}
            >
              {getVoteNumber()}
            </div>
          )}

          <button
            className={cn(styles.feedback_voteIcons, {
              [styles.feedback_downvote__active]:
                feedback.downvotes &&
                feedback.downvotes.includes(state.user?.uid),
            })}
            onClick={downvote}
          >
            <ArrowDownwardRounded fontSize="inherit" />
          </button>
        </div>
      </div>

      <div className={styles.feedback_contentWrapper}>
        {!editting && (
          <div className={styles.feedback_content}>
            <div className={styles.feedback_content_topContent}>
              <CardUser detailsHidden user={feedback.user} small />

              <div className={styles.feedback_content_userName}>
                <Link
                  to={`/profile/${feedback?.user?.id}`}
                  style={{ color: "var(--grey-6)" }}
                >
                  {feedback.user.name}
                </Link>{" "}
                {feedback.user?.reputations && (
                  <span
                    className={styles.feedback_content_userName_reputations}
                  >
                    · {feedback.user?.reputations} reputations
                  </span>
                )}{" "}
                {feedback.user.role === "admin" && (
                  <span className={styles.feedback_content_userName_admin}>
                    admin
                  </span>
                )}
              </div>

              <div style={{ flexGrow: 1 }} />

              {state.user?.uid !== feedback.uid && state.user?.uid && (
                <button
                  aria-label="mentoring endorse"
                  className={cn(styles.feedback_endorsementButton, {
                    [styles.feedback_endorsementButton__endorsed]: endorsed,
                    [styles.feedback_endorsementButton__disabled]: endorsing,
                  })}
                  onClick={() => endorse("Mentoring", feedback.uid)}
                  disabled={endorsing || endorsed}
                >
                  <div className={styles.feedback_endorsementButton_label}>
                    Mentoring
                  </div>{" "}
                  {endorsing ? (
                    <CircularProgress size={12} thickness={4} />
                  ) : endorsed ? (
                    <CheckRounded fontSize="inherit" />
                  ) : (
                    <AddRounded fontSize="inherit" />
                  )}
                </button>
              )}

              {state.user?.uid === feedback.uid && (
                <MUButton
                  variant="text"
                  type="button"
                  style={{
                    textTransform: "lowercase",
                    fontFamily: "var(--heading-font-family)",
                    color: "var(--blue-light)",
                    fontSize: "var(--text-2xs)",
                  }}
                  size="small"
                  onClick={() => setEditting(true)}
                  aria-label="edit feedback"
                >
                  edit
                </MUButton>
              )}
            </div>

            <ReactMarkdown
              renderers={{ code: CodeBlock }}
              source={feedback.content}
            ></ReactMarkdown>
          </div>
        )}

        {state.user && editting && (
          <form onSubmit={onSubmit}>
            <TextareaAutosize
              onChange={(e: any) => setUpdatedContent(e.target.value)}
              value={updatedContent}
              className={styles.feedback_textInput}
              name="feedback"
              aria-label="feedback"
              rowsMin={5}
              placeholder="Feedback"
            />
            <div className={styles.feedback_helperText}>
              You can use Markdown to write and format your feedback.
            </div>

            <Collapse in={!!feedback}>
              <div className={styles.feedback_buttons}>
                <Button
                  aria-label="cancel"
                  loading={loading}
                  type="button"
                  buttonVariant="default"
                  size="small"
                  style={{
                    marginRight: "var(--space-xs)",
                  }}
                  onClick={() => {
                    setEditting(false);
                    setUpdatedContent(feedback.content);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  aria-label="update"
                  type="submit"
                  size="small"
                  loading={loading}
                  disabled={feedback.content === updatedContent}
                >
                  Update
                </Button>
              </div>
            </Collapse>
          </form>
        )}

        {showReplies && (
          <>
            <div className={styles.feedback_replySection}>
              <div className={styles.feedback_replySection_replyRow}>
                {(state.user || feedback.replies.length > 0) && (
                  <>
                    <button
                      className={styles.feedback_replySection_replyButton}
                      onClick={() => setOpenReply(!openReply)}
                    >
                      Replies{" "}
                      {!openReply ? (
                        <ArrowDropDownRounded fontSize="inherit" />
                      ) : (
                        <ArrowDropUpRounded fontSize="inherit" />
                      )}
                    </button>

                    <span>{feedback.replies.length} replies</span>
                  </>
                )}
              </div>

              <span className={styles.feedback_replySection_submittedTime}>
                {moment(feedback.submittedAt).toNow()}
              </span>
            </div>

            <Collapse in={openReply}>
              <Replies
                replies={feedback.replies}
                getFeedbacks={getFeedbacks}
                feedbackId={feedback.id}
              />
            </Collapse>
          </>
        )}
      </div>
    </div>
  );
};

export default Feedback;
